import React, { useEffect } from 'react';

import '../../css/main.css';

import { TextField } from '@material-ui/core';


function CustomInputDateFromTo({ 
    id, name, defaultValue,
    id2, name2, defaultValue2,
    onChange }) {

    useEffect(() => {

        if (defaultValue) {
            let temp = document.getElementById(id);
            temp.value = defaultValue;
        }
        if (defaultValue2) {
            let temp2 = document.getElementById(id2);
            temp2.value = defaultValue2;
        }

    }, [id, id2, defaultValue, defaultValue2]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        let event = {
            target: {}
        };
        event.target["name"] = name;
        event.target["value"] = value;

        if (onChange) {
            onChange(event);
        }
    };

    return (
        <>
            <div className={"h_Label1L"} style = {{width:"250px"}}>

                <TextField
                    id={id}
                    name={name}
                    className={"k_input"}
                    type="date"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        max:"9999-12-31"
                      }}
                    variant="outlined"
                    onChange={handleChange}
                    defaultValue={defaultValue}
                    style={{ float: "left", width: "42.5%" }}
                />

                <div style={{float:"left", width: `calc(10% - 8px - 5px )`, paddingTop:"8px", paddingLeft:"5px" }}> ~ </div>

                <TextField
                    id={id2}
                    name={name2}
                    className={"k_input"}
                    type="date"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        max:"9999-12-31"
                      }}
                    variant="outlined"
                    onChange={handleChange}
                    defaultValue={defaultValue2}
                    style={{ float: "left", width: "42.5%" }}
                />
            </div>
        </>
    );
}

export default CustomInputDateFromTo;